const COMMA_SPACE_MULTI_SPACE_REGEX = /(,(\s+)?|\s\s+)/g;

/**
 * Splits a string by commas and spaces, removes extra white space
 *
 * @param  {string} str comma or space separated string to be split
 * @return {array}      list of split strings
 */
export const splitByCommaOrSpace = (str) =>
    str
        // change all commas to spaces and trim all multispace to single space
        .replace(COMMA_SPACE_MULTI_SPACE_REGEX, ' ')
        // split on single space
        .split(' ')
        // filter empties
        .filter((s) => !!s);
